export const CUSTOMER_TAGS_STATS = "CUSTOMER_TAGS_STATS";
export const CUSTOMER_TAGS_STATS_SUCCESS = "CUSTOMER_TAGS_STATS_SUCCESS";
export const CUSTOMER_TAGS_STATS_FAIL = "CUSTOMER_TAGS_STATS_FAIL";
